import styled from 'styled-components';
import { palette } from 'styled-theme';
import bgImage from '../../../assets/images/background.svg';
import WithDirection from '../../../library/helpers/rtl';

const SignInStyleWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  position: relative;
  background: url(${bgImage}) no-repeat center center;
  opacity: 0.9;
  background-size: cover;

  @media (min-width: 769px) {
    display: flex;
    position: relative;
    justify-content: space-between;
  }

  @media (max-width: 768px) {
    display: block;
    padding: 0 20px 20px 20px;
    height: fit-content;

  }

  .left-content {
    @media (min-width: 769px) {
      position: flex-start;
      display: flex;
      flex-direction: column;
      z-index: 100;
      margin-left: 55px;
      height: 100%;
      justifyContent: space-between;
      position: relative;
      width: 55%
    }
    @media (max-width: 768px) {
      position: relative;
      z-index: 1;
    }
  }
    
  .carousel {
    @media (max-width: 768px) {
      display: none;
    }
  }

 .atmoslyLogo {
    @media (min-width: 769px) {
      width: 257.9px;
      height: 54px;
      margin-top: 20px;
      margin-bottom: 50.4px;
      margin-left: -30px;
    }

    @media (max-width: 768px) {
      width: 128px;
      height: 46px;
      margin-top: 20px;
    }
  }

  .atmoslyTitle {
    font-size: 56px;
    font-family: Poppins semibold;
    color: white;
    margin-bottom: 18px;
    font-weight: 600;
    width: 70%;
    @media (max-width: 768px) {
      width: fit-content;
      flex-grow: 0;
      font-family: Poppins;
      font-size: 26px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
      margin-top: 14.82px;
      margin-bottom: 0;
    }
  }

  .atmoslySubTitle {
    font-family: Nunito Sans;
    font-size: 30px;
    color: white;
    width: 70%;

    @media (max-width: 768px) {
      flex-grow: 0;
      margin: 4.9px 4px 0px 0;
      font-family: Nunito Sans;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.4;
      letter-spacing: normal;
      text-align: left;
      color: rgba(255, 255, 255, 0.6);
      width: fit-content;
    }
  }

  .imgDiv {
    height: 35px;
    display: -webkit-inline-flex;
    display: -ms-inline-flex;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 35px;
    border-radius: 50%;
    margin-right: 20px;
    border: 2px solid white;
  }

  .imgDivStyle{ 
    margin-top: -5px;
    height: 45px;
    display: -webkit-inline-flex;
    display: -ms-inline-flex;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 35px;
    border-radius: 50%;
    margin-right: 20px;
    border: 5px solid white;
  }

  .imgDiv:hover {
    /*margin-top: -5px;
    width: 45px;
    height: 45px;
    border: 2px solid white;*/
  }
  
  .imgStyle {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    display: flex;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 1;
    top: 0;
    left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '0')};
    right: ${props => (props['data-rtl'] === 'rtl' ? '0' : 'inherit')};
  }

  .isoLoginContentWrapper {
    height: 100%;
    width: 30%;
    overflow-y: auto;
    z-index: 10;
    position: relative;
    right: 0;

    @media (max-width: 768px) {
      // position: static;
      height: fit-content;
      margin-top: 23.47px;
      border-radius: 10px;
      width: 100%;
    }
  }

  .isoLoginContent {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 50px 70px 50px;
    position: relative;
    background-color: #ffffff;

    @media only screen and (max-width: 768px) {
      // width: 100%;
      // padding: 70px 20px;
      padding: 20px 15px;
    }

    .topDiv {
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        align-items: center;
        text-align: left;
        align-items: start;
      }
      @media (min-width: 769px) {
        margin-bottom: 68px;
        margin-top: 70px;
      }
    }

    .titleStyle {
      text-align: center;
      @media (max-width: 768px) {
        height: 27px;
        flex-grow: 0;
        font-family: Poppins;
        font-size: 18px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #222;
      }

      @media (min-width: 769px) {
        font-size: 32px;
      }
      margin-bottom: 2px;
      font-style: Poppins medium;
    }

    .subTitleStyle {
      font-family: Nunito Sans Regular;
      font-size: 18px;
      text-align: center;

      @media (max-width: 768px) {
        flex-grow: 0;
        font-family: Nunito Sans;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: normal;
        text-align: left;
        color: #888;
      }

      @media only screen and (max-width: 1280px) {
        font-size: 14px;
      }
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 50px;
      justify-content: center;
      flex-shrink: 0;

      a {
        font-size: 24px;
        font-weight: 300;
        line-height: 1;
        text-transform: uppercase;
        text-decoration: none;
        color: ${palette('secondary', 2)};
      }
    }

    .isoSignInForm {
      width: 100%;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;

      .isoNameDiv {
        display: flex;
        .isoInputWrapper {
          @media (min-width: 769px) {
            margin-right: 10px;
            width: 50%;
          }
        }
        @media (max-width: 768px) {
          display: block;
        }
      }

      .isoLeftRightComponent {
          @media (max-width: 768px) {
            margin-top: -14px !important; //this will ignore the margin of the last input box
          }
        }

      .isoInputWrapper {
        margin-bottom: 22px;
        @media (max-width: 768px) {
          margin-top: 20px;
          margin-bottom: 20px;
        }
        .form-label {
          display: none;
          @media (max-width: 768px) {
            display: block;
            height: 16px;
            align-self: stretch;
            flex-grow: 0;
            font-family: Poppins;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.33;
            letter-spacing: normal;
            text-align: left;
            color: #1f1f1f;
            margin-bottom: 10px;
          }
        }

        .names {
          width: 100%;
          height: 62px;
          background: #f5f5f5;
          border-radius: 8px;
          // margin-right: 10px;
          @media (max-width: 768px) {
            height: 48px;
            background: white;
            border: solid 1px #eeeef2;
          }
        }
      }

        .inputs {
          width: 100%;
          height: 62px;
          border-radius: 8px;
          @media (min-width: 769px) {
            background: #f5f5f5;
          }
          
          @media (max-width: 768px) {
            background: white;
            height: 48px;
            border: solid 1px #eeeef2;
            background: white;
          }
          .ant-input{
            @media (min-width: 769px) {
              background: #f5f5f5;
            }
            @media (max-width: 768px) {
              background: white;
            }
          }
        }
    
        .inputs:focus {
          border: 1px solid #132f44;
        }

        .names:focus {
          border: 1px solid #132f44;
        }

        .names:focus-within {
          border: 1px solid #132f44;
        }
        
        .inputs:focus-within {
          border: 1px solid #132f44;
        }

        .tandc{
          @media screen and (max-width: 768px) {
            font-size: 12px;
            font-family: Nunito Sans;
            line-height: 1.57;
          }  
        }

        .checkBox {
          color: #132f44;
          span {
            font-family: Nunito Sans;
          }

          @media (max-width: 768px) {
            color: #7c7c7c;
            line-height: 1.57;
            font-size: 12px;
            span {
              font-family: Nunito Sans;
            }
          }
        }

        .checkBox:checked {
          background: #132f44;
        }

        input {
          &::-webkit-input-placeholder {
            color: ${palette('grayscale', 0)};
          }

          &:-moz-placeholder {
            color: ${palette('grayscale', 0)};
          }

          &::-moz-placeholder {
            color: ${palette('grayscale', 0)};
          }
          &:-ms-input-placeholder {
            color: ${palette('grayscale', 0)};
          }
        }
      }

      .isoHelperText {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2;
        color: ${palette('error', 0)};
        padding-left: ${props =>
    props['data-rtl'] === 'rtl' ? 'inherit' : '13px'};
        padding-right: ${props =>
    props['data-rtl'] === 'rtl' ? '13px' : 'inherit'};
        margin: 15px 0 0 0;
        position: relative;
        display: flex;
        align-items: center;

        &:before {
          content: '*';
          color: ${palette('error', 0)};
          padding-right: 3px;
          font-size: 14px;
          line-height: 1;
          position: absolute;
          top: 2px;
          left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '0')};
          right: ${props => (props['data-rtl'] === 'rtl' ? '0' : 'inherit')};
        }
      }

       .isoHelperWrapper {
        margin-top: 50px;
        flex-direction: column;

        @media (max-width: 768px) {
            margin-top: 20px;
            height: 16px;
            align-self: stretch;
            flex-grow: 0;
            span {
              font-family: Nunito Sans !important;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              letter-spacing: normal;
              text-align: center;
              color: #132f44;
            }
        }
      }
      .header__center {
        font-size: 20px;
        display: grid;
        grid-template-columns: 1fr max-content 1fr;
        grid-column-gap: 1.2rem;
        align-items: center;
        color: gray;

        @media (max-width: 768px) {
          font-family: Poppins;
          font-size: 12px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #7c7c7c;
          margin-top: 25px;
        }
    }
    
    .header__center::before,
    .header__center::after {
        content: "";
        display: block;
        height: 1px;
        background-color: #e0e0e0;
    }

    .otherSignin {
      @media (max-width: 768px) {
        display: flex;        
      }
    }

      .isoOtherLogin {
        margin-top: 45px;

        @media (max-width: 768px) {
          margin-top: 25px;
        }

        > a {
          display: flex;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        button {
          width: 100%;
          height: 62px;
          border: 0;
          border-radius: 8px;
          font-weight: 500;
          margin-bottom: 40px;
          background-color: white;

          @media (max-width: 768px) {
            height: 44px;
            flex-grow: 0;
            border-radius: 8px;
            background-color: #132f44;
            margin-bottom: 0;

            &#btnTry {
              display: none;
            }
          }
          

          &.btnFacebook {
            background-color: #3b5998;

            &:hover {
              background-color: darken(#3b5998, 5%);
            }
          }

          &.btnGooglePlus {
            background-color: #ffffff;
            border: 2px solid lightgray;
            margin-top: 40px;
            margin-bottom: 0;
            color: #000000;

            img {
              margin-right: 15px;
              width: 18px;
              height: 18px;
            }

            &:hover {
              background-color: darken(#dd4b39, 5%);
            }

            @media (max-width: 768px) {
              width: 50%;
              margin-right: 10px;
              border: 1px solid #d9d9d9;
              span {
                display: none;
              }
              img {
                height: 27px;
                width: 27px;
                margin-right: 0;
              }
            }
          }

          &.btnAuthZero {
            background-color: #e14615;
            margin-top: 15px;

            &:hover {
              background-color: darken(#e14615, 5%);
            }
          }

          &.btnFirebase {
            background-color: ${palette('color', 5)};
            margin-top: 15px;

            &:hover {
              background-color: ${palette('color', 6)};
            }
          }

          &.btnAccountKit {
            ${'' /* background-color: rgb(150, 189, 235); */}
            margin-top: 15px;

            &:hover {
              ${'' /* background-color: ${palette('color', 6)}; */}
            }
          }
        }
      }

      .isoForgotPass {
        font-size: 12px;
        color: #132f44;
        ${'' /*margin-bottom: 10px;*/}
        text-decoration: none;

        &:hover {
          color: ${palette('primary', 0)};
        }

        @media (max-width: 768px) {
          width: 94px;
          height: 15px;
          flex-grow: 0;
          font-family: Nunito Sans;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: left;
          color: #132f44;
        }
      }

      button {
        font-weight: 500;
      }
    }
  }
`;

export default WithDirection(SignInStyleWrapper);
